module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10rRBHB/tc-custom/9781667441009.jpg?1673608908646",
      "alt": "This image is the cover for the book J. F. K."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("J. F. K.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Chicago Police Lieutenant Jonathan Perry has put the Covid Pandemic in the crosshairs of his investigations. To discover the culprits he will be forced to leave the United States to go to China, Russia ... and Nigeria."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pier-Giorgio Tomatis, Paula Banda Rendón\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pier-Giorgio Tomatis was born in 1965, in Turin and lives in Cantalupa, a pretty town close to the mountains."), _c('br'), _vm._v(" He has always written, short stories and screenplays."), _c('br'), _vm._v(" He collaborated as a freelance journalist with the weekly il monviso and the periodical il piccolo di pinerolo. He was director of the municipal bulletin of saluggia and president of the cultural and social voluntary association sisyphus group. He is the promoter of the to.t.a.le. association for the dissemination of books and performances by zero-kilometer authors. Editor of the projects, reading is magic and 10 small authors, he was a scout educator. He is currently the owner of the Cantalupese publishing house hogwords."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0